<div class="theme-selector">
  <button 
    class="theme-toggle-btn" 
    (click)="toggleSelector()"
    [style.background-color]="getCurrentThemeColor()"
    [attr.aria-label]="'Cambiar tema - Actual: ' + getCurrentThemeDisplayName()"
  >
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" fill="currentColor"/>
      <circle cx="12" cy="12" r="3" fill="currentColor" opacity="0.3"/>
    </svg>
    <span class="theme-name">{{ getCurrentThemeDisplayName() }}</span>
  </button>

  <div class="theme-dropdown" [class.open]="isOpen">
    <div class="theme-dropdown-content">
      <h4 class="theme-dropdown-title">Seleccionar Tema</h4>
      <div class="theme-options">
        <button 
          *ngFor="let theme of themes" 
          class="theme-option"
          [class.active]="theme.name === currentTheme"
          (click)="selectTheme(theme.name)"
          [attr.aria-label]="'Cambiar a tema ' + theme.displayName"
        >
          <div class="theme-preview" [style.background-color]="theme.colors.primary">
            <div class="theme-preview-accent" [style.background-color]="theme.colors.accent"></div>
          </div>
          <div class="theme-info">
            <span class="theme-display-name">{{ theme.displayName }}</span>
            <span class="theme-description">{{ getThemeDescription(theme.name) }}</span>
          </div>
          <div class="theme-check" *ngIf="theme.name === currentTheme">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" fill="currentColor"/>
            </svg>
          </div>
        </button>
      </div>
    </div>
  </div>

  <!-- Overlay para cerrar el selector -->
  <div class="theme-overlay" *ngIf="isOpen" (click)="toggleSelector()"></div>
</div>
